import React, { ReactElement } from 'react';
import {
  Col,
  DateRangePicker,
  Input,
  Label,
  MultiChoice,
  Row,
} from 'idsk-react-components';
import FilterButtons from './FilterButtons';
import MultiChoiceItem from '../../../types/MultiChoiceItem';
import VyhodnotenieMultichoice from './VyhodnotenieMultichoice';
import PriradenePouzivateloviRow from './PriradenePouzivateloviRow';
import getLabel from '../function/getLabel';
import Secured from '../../Secured';
import UserRole from '../../../model/currentuser/UserRole';

interface Props {
  isHromadna?: boolean,
  text: string,
  setText:(text: string) => void,
  from: Date,
  setFrom:(from: Date) => void,
  to: Date,
  setTo:(from: Date) => void,
  typ: MultiChoiceItem[],
  setTyp:(stav: MultiChoiceItem[]) => void,
  stav: MultiChoiceItem[],
  setStav:(stav: MultiChoiceItem[]) => void,
  pripomienkujuciSubjekt: MultiChoiceItem[],
  setPripomienkujuciSubjekt:(pripomienkujuciSubjekt: MultiChoiceItem[]) => void,
  priradeny: MultiChoiceItem[],
  setPriradeny: (priradeny: MultiChoiceItem[]) => void,
  resetFilterHandler():void,
  onSubmit: (event: never) => Promise<void>,
}

const FilterForm = ({
  isHromadna = false,
  text,
  setText,
  from,
  setFrom,
  to,
  setTo,
  typ,
  setTyp,
  stav,
  setStav,
  pripomienkujuciSubjekt,
  setPripomienkujuciSubjekt,
  priradeny,
  setPriradeny,
  resetFilterHandler,
  onSubmit,
}:Props):ReactElement => (
  <form className="idsk-table-filter__filters" onSubmit={onSubmit} onReset={resetFilterHandler}>
    <Row>
      <Col width="one-half">
        <Label htmlFor="Hľadaný výraz">Hľadaný výraz</Label>
        <Input
          name="Hľadaný výraz"
          onChange={(e) => {
            setText(e.target.value);
          }}
          type="text"
          maxLength={40}
          placeholder="Hľadaný výraz"
          value={text}
        />
      </Col>
      <Col width="one-half">
        <Label htmlFor="Dátum doručenia pripomienky">Dátum doručenia pripomienky</Label>
        <DateRangePicker
          startDate={from}
          endDate={to}
          onChangeFrom={setFrom}
          onChangeTo={setTo}
        />
      </Col>
    </Row>
    <Row>
      <Col width="one-quarter">
        <Label htmlFor="Typ pripomienky">Typ pripomienky</Label>
        <MultiChoice
          disabled={isHromadna}
          id="multi-choice-typ"
          data={typ}
          onChange={(newData) => {
            setTyp(newData);
          }}
          label={(size) => getLabel(size, typ)}
        />
      </Col>
      <Col width="one-half">
        <Label htmlFor="pripomienkujuci-subjekt">Pripomienkujúci subjekt</Label>
        <MultiChoice
          id="pripomienkujuci-subjekt"
          data={pripomienkujuciSubjekt}
          onChange={(newData) => {
            setPripomienkujuciSubjekt(newData);
          }}
          searchable
          label={(size) => getLabel(size, pripomienkujuciSubjekt)}
        />
      </Col>
      <Col width="one-quarter">
        <Secured allowForRoles={[UserRole.VYHODNOCOVATEL]} elseChildren={<FilterButtons />}>
          <VyhodnotenieMultichoice stav={stav} setStav={setStav} />
        </Secured>
      </Col>
    </Row>
    <Secured allowForRoles={[UserRole.VYHODNOCOVATEL]}>
      <PriradenePouzivateloviRow
        priradeny={priradeny}
        setPriradeny={setPriradeny}
      />
    </Secured>
  </form>
);

export default FilterForm;
